import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { ArcButton } from "@/components/ArcButton";
import { toast } from "sonner";

export default function SuggestEdit() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    article: params.get("article") || "",
    article_slug: params.get("slug") || "",
    suggested_change: "",
    source: "",
    reason: "",
    submitter_email: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.article.trim() || !form.suggested_change.trim()) { toast.error("Article and suggested change are required."); return; }
    setSubmitting(true);
    try {
      await api.post("/contributions", form);
      toast.success("Thank you — your suggestion was submitted for review.");
      navigate(-1);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally { setSubmitting(false); }
  };

  return (
    <div className="mx-auto max-w-2xl px-4 py-12 sm:px-6">
      <h1 className="font-serif-arc text-3xl font-black tracking-tight sm:text-4xl">Suggest an Edit</h1>
      <p className="mt-3 text-sm" style={{ color: "var(--arc-text-2)" }}>
        Submit a correction or addition. An administrator will review it before it appears in the archive.
      </p>

      <form onSubmit={submit} className="mt-8 space-y-5 rounded-md border p-6 shadow-sm" style={{ backgroundColor: "var(--arc-card)" }}>
        <div className="space-y-2">
          <Label>Article</Label>
          <Input data-testid="suggest-article" value={form.article} onChange={set("article")} placeholder="Which article?" />
        </div>
        <div className="space-y-2">
          <Label>Suggested change *</Label>
          <Textarea data-testid="suggest-change" value={form.suggested_change} onChange={set("suggested_change")} rows={5} placeholder="Describe the change you're proposing…" />
        </div>
        <div className="space-y-2">
          <Label>Source</Label>
          <Input data-testid="suggest-source" value={form.source} onChange={set("source")} placeholder="Link or reference (optional)" />
        </div>
        <div className="space-y-2">
          <Label>Reason</Label>
          <Textarea data-testid="suggest-reason" value={form.reason} onChange={set("reason")} rows={3} placeholder="Why should this change be made? (optional)" />
        </div>
        <div className="space-y-2">
          <Label>Your email (optional)</Label>
          <Input data-testid="suggest-email" value={form.submitter_email} onChange={set("submitter_email")} placeholder="So we can follow up (optional)" />
        </div>
        <ArcButton variant="ghoulax" type="submit" disabled={submitting} data-testid="suggest-submit" className="w-full sm:w-auto">
          {submitting ? "Submitting…" : "Submit Suggestion"}
        </ArcButton>
      </form>
    </div>
  );
}
